import $axios from '@/api.js'

const state = () => ({
    carts: [],
})

const mutations = {
    SET_CART(state, payload) {
        state.carts = payload
    },
    REMOVE_ALL_CART(state) {
        state.carts = []
    }
}

const getters = {
    GET_CARTS(state) {
        return state.carts
    },
    COUNT_CART(state) {
        let count = 0
        if (state.carts.length > 0) {
            state.carts.map(cart => {
                count += Number(cart.quantity)
            })
        } 
        return count;
    }
}

const actions = {
    getCarts({commit}, payload) {
        const user_id = payload
        $axios.post('cart/get_data_cart', {
            id_cust: user_id
        }).then(res => {
            if (res.status == 200) {
                const data = res.data
                if (data.success == 1) {
                    const carts = data.data_cart
                    const cartTemp = []
                    carts.map(element => {
                        let price = element.price2
                        // if (element.price_level_) {
                        //     if (element.price_level_.length > 0) {
                        //         const price_level = element.price_level_
                        //         for(let i = 0; i < price_level.length; i++) {
                        //             if (i == price_level.length - 1) {
                        //                 if (Number(element.qty) >= Number(price_level[i].min_qty)) {
                        //                     price = price_level[i].price
                        //                     break;
                        //                 }
                        //             } else {
                        //                 if (Number(element.qty) >= Number(price_level[i].min_qty) && Number(element.qty) < Number(price_level[i + 1].min_qty)) {
                        //                     price = price_level[i].price
                        //                     break;
                        //                 }
                        //             }
                        //         }
                        //     }
                        // }
                        cartTemp.push({
                            product_id: element.id,
                            name: element.name,
                            code: element.code,
                            image: element.image,
                            quantity: Number(element.qty),
                            weight: element.weight,
                            in_promo: element.in_promo,
                            disc_value: element.disc_value,
                            price_level: element.price_level_,
                            min_qty: element.min_qty,
                            max_qty: element.max_qty,
                            price: price,
                            old_price: element.price,
                            total_price: element.qty * price,
                            error_message: '',
                        })
                    })
                    commit('SET_CART', cartTemp)
                } else {
                    commit("SET_ALERT", {
                        status: true,
                        color: "error",
                        message: data.msg
                    }, { root: true })
                }
            } 
        })
    },
    deleteCart({dispatch}, payload) {
        const user_id = payload.user_id
        const product_id = payload.product_id
        $axios.post('cart/delete_cart1', {
            id_prod: product_id,
            id_cust: user_id
        }).then(res => {
            if (res.status == 200) {
                const data = res.data
                if (data.success == 1) {
                    dispatch('getCarts', user_id)
                } else {
                    commit("SET_ALERT", {
                        status: true,
                        color: "error",
                        message: data.msg
                    }, { root: true })
                }
            }
        })
    }
}

export default {
    state,
    mutations,
    actions,
    namespaced: true,
    getters
}